'use client'
import React from 'react'
import parse, { domToReact } from 'html-react-parser';
import tailwindConfig from '@tailwind.config'

const options = {
    replace: ({ name, attribs, children }) => {
      if (!attribs) return;
  
      if (name === 'h1') {
        return (
          <h1 className="text-2xl font-bold mb-2" {...attribs}>
            {domToReact(children, options)}
          </h1>
        );
      }
      if (name === 'h2') {
        return (
          <h2 className="text-2xl font-semibold mb-1" {...attribs}>
            {domToReact(children, options)}
          </h2>
        );
      }
      if (name === 'h3') {
        return (
          <h3 className="text-xl font-semibold" {...attribs}>
            {domToReact(children, options)}
          </h3>
        );
      }
      if (name === 'strong') {
        return (
          <strong className="text-xl font-bold" {...attribs}>
            {domToReact(children, options)}
          </strong>
        );
      }
      if (name === 'a') {
        return (
          <a className="font-semibold hover:font-bold underline underline-offset-2" {...attribs}>
            {domToReact(children, options)}
          </a>
        );
      }
    },
  };

const BlogPartialComponent = ({ html }) => {
    const style = {
        color: tailwindConfig.theme.extend.colors.secondary,
    };

    return (
        <div className='mb-2 pb-2'>
            <div /*className='text-justify'*/>
                <>
                    <div style={style}>
                        {parse(`${html}`, options)}
                    </div>
                </>
            </div>
        </div>
    )
}

export default BlogPartialComponent